<template>
    <img src="/images/promo/connect-features/crying-face.png"
     alt="Crying Face" />
</template>

<script>
export default {};
</script>
